export namespace HoverSquare {
  export namespace Plugin {
    export const Name = 'hover-square';
  }
}
